import { NgModule } from "@angular/core";

import { AdBlockDetectorService } from "./ad-block-detector.service";

@NgModule({
  providers: [AdBlockDetectorService]
})
export class AdBlockDetectorModule {}
